import { twMerge } from 'tailwind-merge';
import type { UnisonProjectTypeId } from '@witmetrics/utils';
import { isAiProjectType } from '@witmetrics/utils/unisonProjects';
import AiBadge from '@/components/AiBadge';
import CaseTypeIcon from '@/components/CaseTypeIcon';
import InfoPoint from '@/components/InfoPoint';
import { AiMarkIcon } from '@/icons';
import { classes } from './utils';

export type CaseTypeBlockProps = {
  condensed?: boolean;
  projectTypeId: UnisonProjectTypeId;
  title: string;
  description: string;
  src?: string;
  titleSize?: 'sm';
  onSelect: () => void;
};

export default function CaseTypeBlock({
  condensed,
  projectTypeId,
  title,
  titleSize,
  description,
  src,
  onSelect,
}: CaseTypeBlockProps) {
  const showAiIcon = isAiProjectType(projectTypeId);

  if (condensed) {
    return (
      <div className={classes.condensedWrapper} onClick={onSelect}>
        <div className={classes.imageWrapper}>
          {src ? (
            <img className={classes.image} src={src} alt={title} />
          ) : (
            <div className={classes.placeholder}>
              <CaseTypeIcon
                className={classes.placeholderIconWrapper}
                projectTypeId={projectTypeId}
                iconClassName={classes.placeholderIcon}
              />
            </div>
          )}
          {showAiIcon && (
            <span className={classes.aiMark}>
              <AiMarkIcon />
            </span>
          )}
        </div>
        <div className={classes.condensedTitle}>{title}</div>
        <div className={classes.infoWrapper}>
          <InfoPoint
            placement="top"
            iconClassName={classes.infoIcon}
            content={description}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={classes.wrapper} onClick={onSelect}>
      <CaseTypeIcon projectTypeId={projectTypeId} />
      <div className={classes.titleWrapper}>
        <div
          className={twMerge(
            classes.title,
            titleSize === 'sm' ? classes.titleSm : classes.titleBase
          )}>
          {title}
          {showAiIcon && <AiBadge className={classes.aiBadge} />}
        </div>
        <div className={classes.description}>{description}</div>
      </div>
    </div>
  );
}
